<template>
    <div>
        <div
                v-if="errorMessage !== null"
                class="alert alert-danger">
            {{ 'Error' | trans }} - {{ errorMessage }}
        </div>
        <div
                v-else-if="state === 'loading'"
                class="alert alert-info">
            {{ 'Loading' | trans }}...
        </div>
        <template v-else-if="state === 'loaded'">
            <br>
            <div
                    v-if="refundInfos !== null && user.workerIsNovice !== true"
                    class="alert alert-warning">
                {{ 'job_impossible_refund_warning_part_1' | trans }}
                {{ 'refund_warning_part_2' | trans(refundInfosForDisplay) }}
                <nl2br tag="div" v-bind:text="$options.filters.trans('partial_refund_policy').replace(/_percents_/g, '%')"/>
            </div>
            <strong>{{ 'Explain why' | trans }}</strong>
            <textarea
                    v-model="description"
                    class="form-control">
            </textarea>
            <p>
                {{ 'Please write at least 5 letters to validate your comment' | trans }}
            </p>
            <div class="row">
                <div class="col-xs-6">
                    <button
                            v-on:click="$emit('form:cancelled')"
                            class="btn">
                        {{ 'Back' | trans }}
                    </button>
                </div>
                <div class="col-xs-6">
                    <button
                            v-on:click="submit"
                            v-bind:disabled="!submitAllowed"
                            class="btn btn-primary">
                        {{ 'Impossible' | trans }}
                    </button>
                </div>
            </div>
        </template>
        <div
                v-else-if="state === 'submitting'"
                class="alert alert-info">
            {{ 'Sending' | trans }}...
        </div>
        <div
                v-else-if="state === 'submitted'"
                class="alert alert-success">
            {{ 'Thanks' | trans }} !
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            job: Object,
            user: Object
        },
        data() {
            return {
                errorMessage: null,
                state: 'loading',
                refundInfos: null,
                description: '',
            }
        },
        async created() {
            try {
                this.refundInfos = await this.$api.job.getRefundInfos(this.job.id);
                this.state = 'loaded';
            }
            catch (error) {
                if (this.$api.is401(error)) {
                    // in case of 401, just abort javascript execution
                    return;
                }
                if (this.$api.isNoConnectivity(error)) {
                    this.errorMessage = this.$options.filters.trans('No connection ?');
                } else {
                    this.$bugsnagClient.notify(error);
                    this.errorMessage = this.$options.filters.trans('Unknown error');
                }
            }
        },
        methods: {
            async submit() {
                if (!this.submitAllowed) {
                    return;
                }
                this.state = 'submitting';
                try {
                    await this.$api.job.markAsImpossible(this.job.id, this.description);
                    this.state = 'submitted';
                    this.$emit('form:submitted');
                }
                catch (error) {
                    if (this.$api.is401(error)) {
                        // in case of 401, just abort javascript execution
                        return;
                    }
                    if (this.$api.isNoConnectivity(error)) {
                        this.errorMessage = this.$options.filters.trans('No connection ?');
                    } else {
                        this.$bugsnagClient.notify(error);
                        this.errorMessage = this.$options.filters.trans('Unknown error');
                    }
                }
            },
        },
        computed: {
            refundInfosForDisplay() {
                if (this.refundInfos === null) {
                    return null;
                }
                return {...this.refundInfos, refundPercentage: this.refundInfos.refundRatio*100 + '%'};
            },
            submitAllowed() {
                return (
                    this.description.length > 5
                    && this.state === 'loaded'
                );
            },
        },
    }
</script>
